export const NAV_LINKS = [
  { title: "How It Works?", url: "#howItWork" },
  { title: "Features", url: "#features" },
  { title: "Pricing", url: "#pricing" },
  { title: "FAQs", url: "#faqs" }
];
